import { makeAutoObservable } from 'mobx'

class _NotificationsStore {
  count: number = 0

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setCount = (count: number): void => {
    this.count = count
  }

  reduceCount = (): void => {
    if (this.count > 0) {
      this.count -= 1
    }
  }
}

const NotificationsStore = new _NotificationsStore()

export { NotificationsStore }
